import React, { useRef, useState, useEffect } from 'react';
import { firestore } from '../../configs/environments/firebase/firebaseApp';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { isBrowser, isMobile } from 'react-device-detect';
import CardSedes from './CardSedes';
import CardEsp from './CardEsp';
import ScrollToTop from '../../components/ScrollToTop';
import CardPremiumMainHolder from '../../components/ViewProfile/CardPremiumMainHolder';
import CardCertification from '../../components/ViewProfile/CardCertification';
import CardAward from '../../components/ViewProfile/CardAward';
import CardLaboral from '../../components/ViewProfile/CardLaboral';
import CardPublication from '../../components/ViewProfile/CardPublication';
import FormClient from '../../components/ViewProfile/Form/';
import CardGeneralData from './CardGeneralData';
import CardOpinion from '../../components/ViewProfile/CardOpinion/';
import CardValoration from '../../components/ViewProfile/CardValoration/';
import CardLawyerAnswers from '../../components/ViewProfile/CardLawyerAnswers';
import CardResponseTime from '../../components/ViewProfile/CardResponseTime';
import CardExperience from './CardExperience';
import CardVideos from './CardVideos';
import CardSocialNetworks from './CardSocialNetworks';
import CardPhotos from './CardPhotos';
import CardCost from './CardCost';
import CardLawyers from './CardLawyers';
import CardColaborators from './CardColaborators';
import FormDialog from './Form/FormDialog';
import { connect } from 'react-redux';
import axios from 'axios';
import CardSchedule from './CardSchedule';
import CardEducation from './CardEducation';
import CardCourses from './CardCourses';
import './ViewLawyer.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '0 40px',
    paddingBottom: 104,
    '@media (max-width: 1359px)': {
      margin: 0,
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));
const ViewLawyer = ({ user, client }) => {
  const [opinions, setOpinions] = useState([]);
  const [rate, setRate] = useState(0);
  const [visibleOpinions, setVisibleOpinions] = useState([]);
  const classes = useStyles();
  const small = useMediaQuery('(max-width:959px)');
  const desktopVersion = useMediaQuery('(min-width: 769px)');
  //const [openForm, setOpenForm] = useState(false);
  /*This helps to get the textfield ref */
  const refInputName = useRef(null);
  const handleContactButton = () => {
    refInputName.current.focus();
    console.log('click', refInputName);
  };
  /*  const handleOpenForm = () => {
    setOpenForm(true)
  }
  const closeForm = () => {
    setOpenForm(false);
  } */
  //console.log('client', client)

  const isEmpty = obj => {
    if (obj === undefined) {
      return true
    } else {
      return Object.keys(obj).length === 0;
    }
  }

  useEffect(() => {
    user && user.uid && process_opinion(user.uid);
    user && user.uid && process_view(user.uid);
  }, [user]);

  function process_view(uid) {
    axios
      .post(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/create/profile_view_analytics?lawyerUid=${uid}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  }

  function process_opinion(uid) {
    let wholeData = [];
    console.log('uid', uid);

    firestore
      .collection('opinions')
      .doc(uid)
      .collection('opinion')
      .get()
      .then((querySnapshot) => {
        console.log('querySnapshot', querySnapshot);
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          wholeData.push(doc.data());
        });
        const filteredData = wholeData.filter((elem) => {
          if (!elem.visible) {
            return null;
          }
          return elem;
        });
        setVisibleOpinions(filteredData);
      })
      .catch((error) => {});

    let x = wholeData.reduce(function (acc, obj) {
      return acc + obj.rating;
    }, 0); // 7
    let totalRate = Number(x / wholeData.length).toFixed(1);
    let num = isNaN(totalRate) ? 0 : totalRate;
    console.log('test1', num);
    setRate(num);
    console.log('wholeData', wholeData);
    setOpinions(wholeData);
  }

  return (
    <>
      <div style={{ maxWidth: 1360, margin: 'auto' }}>
        <section
          className="ViewLawyer"
          style={{
            width: '100%',
            flexGrow: 1,
            minHeight: '100vh',
            backgroundColor: '#f6f8fb',
            padding: '24px 0 0',
          }}
        >
          <div className={classes.root}>
            <Grid container spacing={small ? 0 : 4}>
              <Grid item xs={12} md={8}>
                <div>
                  <img
                    src={
                      user && user.imgenPortada
                        ? `/img/profile/cover/${user.imgenPortada}.png`
                        : '/img/profile/cover/23.png'
                    }
                    style={{ width: '100%' }}
                    alt="imagen de portada"
                  />
                </div>
                <div>
                  <CardGeneralData
                    generalData={user} //lawyer-lawfirm data
                    client={client} //user client data
                    handleContactButton={handleContactButton}
                  />
                </div>

                {user && user.idLawFirm ?
                  <div>
                    <CardPremiumMainHolder
                      authClient={user}
                    />
                  </div> : null
                }

                {user && user.experience ?
                  <div>
                    {user.experience && (
                      <CardExperience experience={user.experience} />
                    )}
                  </div> : null
                }
                
                <div>
                  {user.specialties && (
                    <CardEsp specialties={user.specialties} />
                  )}
                </div>
                <div>
                  {user.socialNetworks ? (
                    <CardSocialNetworks
                      socialNetworks={user.socialNetworks}
                    />
                  ) : null}
                </div>

                {user.membership && user.membership.type !== 'Free' && (
                  <>
                    {user.role === 'lawyer' &&
                    user.certificationsLawyer &&
                    user.certificationsLawyer.length !== 0 ? (
                      <div>
                        <CardCertification
                          certification={user.certificationsLawyer}
                        />
                      </div>
                    ) : null}
                    {user.role === 'lawyer' &&
                    user.awardsLawyer &&
                    user.awardsLawyer.length !== 0 ? (
                      <div>
                        <CardAward award={user.awardsLawyer} />
                      </div>
                    ) : null}
                    {user.role === 'lawyer' &&
                    user.laboralsLawyer &&
                    user.laboralsLawyer.length !== 0 ? (
                      <div>
                        <CardLaboral laboral={user.laboralsLawyer} />
                      </div>
                    ) : null}
                    {user.role === 'lawyer' &&
                    user.publicationsLawyer &&
                    user.publicationsLawyer.length !== 0 ? (
                      <div>
                        <CardPublication
                          publication={user.publicationsLawyer}
                        />
                      </div>
                    ) : null}
                    <div>
                      {user && user.role === 'lawFirm' && (
                        <CardLawyers holders={user.holders} />
                      )}
                    </div>
                    <div>
                      {user && user.role === 'lawFirm' && (
                        <CardColaborators lawyers={user.lawyers} />
                      )}
                    </div>

                    {user &&
                    user.role === 'lawyer' &&
                    user.educationLawyer &&
                    user.educationLawyer.length !== 0 ? (
                      <div>
                        <CardEducation education={user.educationLawyer} />
                      </div>
                    ) : null}

                    {user &&
                    user.role === 'lawyer' &&
                    user.coursesLawyer &&
                    user.coursesLawyer.length !== 0 ? (
                      <div>
                        <CardCourses courses={user.coursesLawyer} />
                      </div>
                    ) : null}
                    {(user.sede && isMobile && user.role === 'lawyer') ||
                      (user.sede && user.role === 'lawFirm') ?
                      <CardSedes authClient={user} /> : null
                    }
                    <div>
                      <CardCost
                        authClient={user}
                        client={client}
                        quotation
                        handleClick={handleContactButton}
                      />
                    </div>
                    <div>
                      {user.imgViews ? (
                        <CardPhotos publicImgViews={user.imgViews} />
                      ) : null}
                    </div>
                    <div style={{ marginBottom: small ? 100 : 0 }}>
                      {user.videosYoutube ? (
                        <CardVideos publicVideosYT={user.videosYoutube} />
                      ) : null}
                    </div>

                    <div>
                      {opinions && (
                        <CardOpinion
                          publicView={true}
                          authClient={user}
                          opinions={opinions}
                          rate={rate}
                        />
                      )}
                    </div>
                  </>
                )}
              </Grid>


              {desktopVersion && user.membership && user.membership.type !== 'Free' &&  (
                <Grid item xs={12} md={4}>
                  <div id="contactForm">
                    <FormClient
                      user={user}
                      contact={user && user.contacto}
                      refInputName={refInputName}
                      client={client}
                    />
                  </div>
                  <CardValoration
                    visibleOpinions={visibleOpinions}
                    authClient={user}
                    active={true}
                    client={client}
                    opinions={opinions}
                    rate={rate}
                  />
                  {user && user.community === true ? (
                    <CardResponseTime authClient={user} />
                  ) : null}
                  {user && user.community === true ? (
                    <CardLawyerAnswers authClient={user} />
                  ) : null}
                  {user.sede && user.role === 'lawyer' && !isMobile ?
                    <CardSedes authClient={user} /> : null
                  }
                  {user.schedule && user.schedule.scheduleDays && (
                    <CardSchedule publicSchedule={user.schedule} />
                  )}
                </Grid>
              )}
            </Grid>
          </div>
        </section>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  role: state.authClient.role,
  client: state.authClient,
});
export default connect(mapStateToProps)(ViewLawyer);